import { LOBBY_GAMES_SECTION_COUNT } from '../../constants';

interface IPlaceholderObject {
  isPlaceholder: boolean;
}

export const gamesPlaceholder: IPlaceholderObject[] = new Array(
  LOBBY_GAMES_SECTION_COUNT
)
  .fill(1)
  .map((): IPlaceholderObject => ({ isPlaceholder: true }));
